export default __webpack_public_path__ + "media/Beverage-Tea.4ecd9e67.png";